import { Dialog, DialogBackdrop } from 'reakit/Dialog';
import styled, { css } from 'styled-components';
import { CloseButton } from '../atoms/CloseButton/CloseButton.styled';
import { Modal } from '@virtidev/toolbox';

export const ModalTweaked = styled(Modal)`
  .modal-box {
    max-width: ${(props) => props.$maxWidth ?? '75%'};
    min-width: 300px; //To prevent "X" button from overlapping titles when not a lot of content is to be displayed wihtin the modal.
  }
  .modal-content {
    padding-top: 0;
  }
  ${(props) =>
    props.noPadding &&
    css`
      .modal-header,
      .modal-content {
        height: 0;
        padding: 0;
        ${(props) =>
          props.mediaPreview &&
          css`
            justify-content: center;
          `}
      }
      && .virti-icon-cross-outline:before {
        position: relative;
        z-index: 1;
        top: 0.8rem;
        right: 0.8rem;
      }
      ${(props) =>
        props.mediaPreview &&
        css`
          && .virti-icon-cross-outline:before {
            color: #fff;
            text-shadow: 2px 2px 2px black;
          }
        `}
    `}/* display: ${(props) => (props.$visible ? 'flex' : 'none')};
  position: fixed;
  z-index: 4;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  align-items: center;
  justify-content: center;
  z-index: 1010; */
`;

export const ModalInner = styled.div`
  ${({ theme: { color, borderRadius } }) => css`
    position: relative;
    border-radius: ${borderRadius.md};
    overflow: auto;
    ${(props) =>
      props.maxWidth &&
      css`
        max-width: ${(props) => props.maxWidth};
      `}
    ${(props) =>
      props.side &&
      css`
        position: absolute;
      `}
  ${(props) =>
      props.side === 'right' &&
      css`
        right: 1%;
      `}
  ${(props) =>
      props.side === 'left' &&
      css`
        left: 1%;
      `}
  ${CloseButton} {
      position: absolute;
      right: 1rem;
      top: 1rem;
      z-index: 1;
    }
  `}
`;

export const Content = styled.div``;
export const PaddedContent = styled.div`
  padding: 1rem;
`;
